import {useSelector} from "react-redux";
import {useEffect} from "react";
import {Link, useNavigate} from "react-router-dom";
import {Routes} from "../utils";
import {Preview} from "../components";
import {options} from "../forms/AdvancedConfigurationForm";


export default function SummaryScreen(props) {
    const customer = useSelector(({main}) => main.customerDetails)
    const navigate = useNavigate()
    const {dimensions, config} = useSelector(({main}) => ({
        dimensions: main.dimensions,
        config: main.config,
    }))

    useEffect(() => {
        if (!customer) {
            navigate(Routes.customer)
        }
    }, [])

    if (!customer)
        return null

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-6">
                    <h5>Podgląd</h5>
                    <div className="p-4">
                        <Preview
                            dimensions={dimensions}
                            config={config}
                        />
                    </div>
                </div>
                <div className="col-md-6">

                    <h5>Dane klienta</h5>
                    <InfoGroup label="Imię i nazwisko">
                        {customer.firstname} {customer.lastname}
                    </InfoGroup>
                    <InfoGroup label="Adres">
                        {customer.postcode ? `${customer.postcode}, ` : ''}{customer.city}
                        <br/> {customer.address}
                    </InfoGroup>
                    <InfoGroup label="Telefon kontaktowy">{customer.phone}</InfoGroup>
                    <InfoGroup label="Adres email">{customer.email}</InfoGroup>

                    <div className="mb-4"/>

                    <h5>Wymiary wnęki</h5>
                    <InfoGroup label="Szerokość wnęki">{dimensions.width} cm</InfoGroup>
                    <InfoGroup label="Wysokość wnęki">{dimensions.height} cm</InfoGroup>

                    <div className="mb-4"/>

                    <h5>Konfiguracja</h5>
                    <InfoGroup label="Szerokość drzwi">{config.width} cm</InfoGroup>
                    <InfoGroup label="Wysokość drzwi">{config.height} cm</InfoGroup>
                    <InfoGroup label="Strona otwierania">{config.openingDirection === 'left' ? 'Lewe' : 'Prawe'}</InfoGroup>
                    <InfoGroup label="Model drzwi">{config.product?.label}</InfoGroup>
                    <InfoGroup label="Kolorystyka">{config.color?.label}</InfoGroup>
                    {/*<InfoGroup label="Grubość">{options.depth.find(o => o.value === Number(config.depth))?.label}</InfoGroup>*/}

                    <div className="mb-5"/>

                    <div className="" style={{textAlign: 'right'}}>
                        <Link to={Routes.customer}>
                            <button type="button" className="btn btn-outline-primary" style={{marginRight: '5px'}} disabled>Wstecz</button>
                        </Link>
                        <button
                            type="button"
                            className="btn btn-primary"
                            disabled={props.sending}
                            onClick={props.onSubmit}
                        >
                            Wyślij zapytanie&nbsp;
                            {props.sending && (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
                            )}
                        </button>
                        {!!props.error && (
                            <p className="p-2 small text-danger">Coś poszło nie tak! Spróbuj ponownie.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

function InfoGroup(props) {
    return (
        <div className="infoGroup">
            <div className="row">
                <div className="col-md-5"><span className="infoGroup__label">{props.label}</span></div>
                <div className="col-md-7">{props.children}</div>
            </div>
        </div>
    )
}
